import {DeliveryPointMessageType, IDeliveryPointMessageType} from 'app/blocks/model/delivery-point-message-type.model';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Resource} from 'app/constants/resource';
import EntityCrudService from 'app/blocks/service/api/entity-service';

@Injectable({
    providedIn: 'root'
})
export class DeliveryPointMessageTypeService extends EntityCrudService<IDeliveryPointMessageType> {
    constructor(http: HttpClient) {
        super(http, Resource.DELIVERY_POINT_MESSAGE_TYPES, (obj?) => new DeliveryPointMessageType(obj));
    }
}
